var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-row"},_vm._l((_vm.columns),function(property){return _c('td',{key:property},[_vm._v(" "+_vm._s(_vm.row[property])+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }